import React from "react";
import axios from "axios";
import { Row, Container, Col, Form } from "react-bootstrap";
import { t } from "../../localization/localization";

import { Line } from "react-chartjs-2";
import { toOrganizationCrisId } from "../../utils/crisUtils";

const PALETTE = ["#003f5c", "#58508d", "#bc5090", "#ff6361", "#ffa600"];

export default class ReportsYayinSayisi extends React.Component {
  state = {
    organizations: [],
    datasets: [],
  };

  componentDidMount() {
    axios
      .get(`${window._env_.BASE_URL}/gcris-api/org-unit`)
      .then((res) => {
        this.setState({
          organizations: res.data.map((e, i) => {
            return {
              crisId: toOrganizationCrisId(e.id),
              uuid: e.uuid,
              text: e.ouname,
              checked: i < 3,
            };
          }),
        });
      })
      .then(() => this.reloadData());
  }

  reloadData = async () => {
    const filteredOrgs = this.state.organizations.filter((e) => e.checked);

    const fetchData = (crisId) => {
      return axios
        .get(`${window._env_.BASE_URL}/gcris-api/report/yayinSayisi/${crisId}`)
        .then((res) => {
          return res.data
            .sort((e1, e2) => e1.year - e2.year)
            .map((e) => {
              return { label: e.year, data: e.count };
            });
        });
    };

    var datasets = [];
    for (const [index, org] of filteredOrgs.entries()) {
      const data = await fetchData(org.crisId);
      const dataset = {
        label: org.text,
        fill: false,
        lineTension: 0.1,
        backgroundColor: PALETTE[index % PALETTE.length],
        borderColor: PALETTE[index % PALETTE.length],
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: PALETTE[index % PALETTE.length],
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: PALETTE[index % PALETTE.length],
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: data.map((e) => e.data),
        labels: data.map((e) => e.label),
      };
      datasets.push(dataset);
    }
    this.setState({
      datasets: datasets,
    });
  };

  changeChecked = (uuid) => {
    const orgIndex = this.state.organizations.findIndex(
      (org) => org.uuid === uuid
    );
    let newArray = [...this.state.organizations];
    newArray[orgIndex] = {
      ...newArray[orgIndex],
      checked: !newArray[orgIndex].checked,
    };
    this.setState(
      {
        organizations: newArray,
      },
      () => {
        this.reloadData();
      }
    );
  };

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";

    return (
      <Container>
        <Row>
          <Col xs="4">
            <h4 style={{ color: "#001F54" }}>
              {t(locale, "/reports/yayinSayisi/title")}
            </h4>
            <Form style={{ height: 300, overflowY: "scroll" }}>
              {this.state.organizations.map((org) => {
                return (
                  <Form.Check
                    key={org.uuid}
                    type="checkbox"
                    id={org.crisId}
                    label={org.text}
                    onChange={() => this.changeChecked(org.uuid)}
                    checked={org.checked}
                  />
                );
              })}
            </Form>
          </Col>
          <Col xs="8">
            <Line
              data={{
                labels: this.state.datasets[0]
                  ? this.state.datasets[0].labels
                  : [],
                datasets: this.state.datasets,
              }}
              width={440}
              height={320}
              options={{
                maintainAspectRatio: false,
                plugins: {
                  datalabels: {
                    display: false,
                  },
                },
              }}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}
